/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialCostCenterEditorViewModel } from "../types/CourseFinancialCostCenterEditorViewModel.ts";

export const courseFinancialCostCenterEditorViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do rateio. Zero para incluir; informe o ID existente para manter ou alterar. Os omitidos são removidos.",
      ),
  ),
  costCenterId: z
    .string()
    .describe(
      "GUID do centro de custo no PecegePay. Obrigatório, com 32 dígitos e 4 hifens.",
    )
    .nullish(),
  percentage: z.optional(
    z
      .number()
      .describe(
        "Percentual do rateio. Entre 1 e 100. A soma de todos os rateios precisa ser exatamente 100.",
      ),
  ),
}) as unknown as ToZod<CourseFinancialCostCenterEditorViewModel>;
